import React, { useState, useCallback, useEffect, useMemo } from "react";
import styled, { css } from "styled-components";
import Modal from "./modal";
import FormTitle, { StyledFormTitle } from "components/formTitle";
import InputGroup from "components/inputGroup";
import Button, { StyledButton } from "components/button";
import logger from "utils/logger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFlag } from "@fortawesome/free-regular-svg-icons";
import { faShare, faFlag } from "@fortawesome/free-solid-svg-icons";
import { hoverTips } from "utils/mixin";
import Select from "components/select";
import data from "services/data";
import data_1 from "services/data";
import notifier from "utils/notifier";
import DropArea from "components/dropArea";
import FileInput from "components/fileInput";
import util from "utils/util";
import { values } from "lodash";

const StyledPluginVerModal = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 25px;
`;

const StyledMiddle = styled.div`
  align-self: center;
  justify-self: center;
  color: ${({ theme }) => theme.black};

  ${({ theme, tips }) => hoverTips(theme, tips)}
`;

const StyledButtonGroup = styled.div`
  grid-column: 1/4;
  align-self: center;
  justify-self: center;
`;

const StyledDoublePluginVerModal = styled.div`
  display: grid;
  grid-template-rows: 50px 1fr 50px;
  grid-template-columns: 1fr 60px 1fr;
  row-gap: 20px;

  ${StyledFormTitle} {
    grid-column: 1/4;
    align-self: center;
  }

  ${StyledPluginVerModal} {
    padding: 0 30px;
  }

  /* ${StyledButton} {
    width: 70px;
  } */
`;

const StyledSelectLabel = styled.label`
  color: ${({ theme }) => theme.fontColor};
  font-family: ${({ theme }) => theme.font.youshe};
  font-size: ${({ theme }) => theme.fontSize.slarge};
  opacity: 0.8;
`;

const StyledSelect = styled(Select)`
  color: ${({ theme }) => theme.fontColor};
  font-size: ${({ theme }) => theme.fontSize.normal};
`;

const StyledIcon = styled(FontAwesomeIcon)``;

const StyledSelectGroup = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.fontColor};
`;

const StyledDescArea = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 25px;
  position: relative;

  ${({ areaCss }) => areaCss}
`;

const preventDefaultDrop = (e) => e.preventDefault();

const uploadStatusVariants = {
  noUpload: { type: 0, message: "未上传" },
  uploaded: { type: 1, message: "上传成功" },
  waitUpload: { type: 2, message: "上传中" },
};

const { publishFlagOptions: flagOptions, publishSystem } = data;

const defaultFormNoPluginAppId = {
  buildTime: "",
  changeInfo: "",
  changeInfoEn: "",
  version: "",
  publishFlag: 1,
  pluginVerHash: "",
  fileId: "",
  publishSystem: "windows",
};

const PluginVerModal = ({
  module,
  errorMessage,
  pluginAppId,
  visible, // 是显示模态框还是隐藏模态框
  type, // 模态框的类型 是添加还是修改
  data, //点击了的插件的版本信息
  displayTargetPlugin = false,
  onClose,
  onFileUpload,
  onPluginVerAdd,
  onPluginVerUpdate,
}) => {
  const [pluginInfo, setPluginInfo] = useState(null);

  // 获取插件的信息, 就是插件的信息 不是插件版本的信息
  const getPluginInfo = useCallback(async (appId) => {
    if (!appId) return;
    try {
      const plugin = await data_1.getPluginInfoByAppId(appId);
      setPluginInfo(plugin);
    } catch (e) {
      notifier.error(e.message);
    }
  }, []);
  useEffect( () => {
    getPluginInfo(pluginAppId)
  },[pluginAppId])
  if(!module) {
    module = pluginInfo?.module
  }

  const [form, setForm] = useState({
    pluginAppId,
    buildTime: "",
    changeInfo: "",
    changeInfoEn: "",
    version: "",
    publishFlag: 1,
    pluginVerHash: "",
    fileId: "",
    publishSystem: "",
  });
  // 单独拿出来 不与form在一起更新 提交form时生成fileId加入到form中
  const [file, setFile] = useState('');
  const [uploadStatus, setUploadStatus] = useState(
    uploadStatusVariants.noUpload
  );

  useEffect(() => {
    if (type === "add") {
      setForm({
        pluginAppId,
        ...defaultFormNoPluginAppId,
      });
    } else if (data && type === "update") {
      logger.log("是修改插件版本：", data);
      const {
        version,
        changeInfo,
        changeInfoEn,
        buildTime,
        fileId,
        publishFlag,
        pluginVerHash,
        publishSystem,
      } = data;
      setForm({
        version,
        changeInfo,
        changeInfoEn,
        buildTime,
        publishFlag,
        pluginVerHash,
        fileId,
        publishSystem,
      });
    }
    console.log("pluginVerModal 添加阻止window drop行为");
    // prevent browser's default file drop behavior
    window.addEventListener("dragover", preventDefaultDrop);
    window.addEventListener("drop", preventDefaultDrop);
    return () => {
      console.log("pluginVerModal 移除阻止window drop行为");
      window.removeEventListener("dragover", preventDefaultDrop);
      window.removeEventListener("drop", preventDefaultDrop);
    };
  }, [data, pluginAppId, type]);

  const handleValueChange = useCallback(
    (name, value) => {
      const copy = { ...form };
      copy[name] = value;
      setForm(copy);
    },
    [form]
  );

  const validate = useCallback(() => {
    const { buildTime, changeInfo, version } = form;
    if (buildTime && changeInfo && version) {
      return true;
    }
    return false;
  }, [form]);

  // const handleFile = useCallback(
  //   (files) => {
  //     const file = files[0];
  //     if (!file) return;
  //     console.log("文件：", file);
  //     if (file.name.startsWith(module + "-")) {
  //       setFile(file);
  //       const [flag] = file.name.slice(module.length + 1).split("-", 1);
  //       console.log('flag',flag);
  //       handleValueChange("publishSystem", flag);
  //     } else {
  //       notifier.error(`选择失败，文件应以"${module}-"开头`);
  //       return "invalid file";
  //     }
  //   },
  //   [module, handleValueChange]
  // );

  const handleFile = useCallback(
    (files) => {
      const validFiles = [];
      let flags = [];
      for (const file of files) {
        if (!file) continue;
        console.log("文件：", file);
        if (file.name.startsWith(module + "-")) {
          validFiles.push(file);
          let flag = file.name.slice(module.length + 1).split("-", 1);
          if (file.name.includes('linux-arm64')) {
            flag = 'linux-arm64'
          } else if (file.name.includes('linux')) {
            flag = 'linux'
          } else if (file.name.includes('windows')) {
            flag = 'windows'
          }
          flags.push(flag);
        } else {
          notifier.error(`选择失败，文件应以"${module}-"开头`);
          return "invalid file";
        }
      }
      handleValueChange("publishSystem", flags);
      // setFileName(fn);
      setFile(validFiles);
    },
    [module, handleValueChange]
  );

  // 上传文件并返回fileId
  // const handleFileUpload = useCallback(async () => {
  //   // 上传文件
  //   if (!file) {
  //     setUploadStatus(uploadStatusVariants.noUpload);
  //     notifier.error("请选择文件");
  //     return [];
  //   }
  //   //状态改为上传中
  //   setUploadStatus(uploadStatusVariants.waitUpload);
  //   // 开始 并等待上传
  //   const [isSuccess, id, message] = await onFileUpload(
  //     file,
  //     (percent, loaded, total) => {
  //       setUploadStatus({
  //         ...uploadStatusVariants.waitUpload,
  //         message: `${uploadStatusVariants.waitUpload.message} ${percent}%`,
  //       });
  //     }
  //   );
  //   if (isSuccess) {
  //     logger.log("上传完成", isSuccess, file.name, id, form);
  //     //状态改为上传成功
  //     setUploadStatus(uploadStatusVariants.uploaded);
  //     setForm((f) => ({ ...f, fileId: id }));
  //   } else {
  //     //状态改为上传失败 message
  //     const noUpload = { ...uploadStatusVariants.noUpload };
  //     noUpload.message = message;
  //     setUploadStatus(noUpload);
  //   }

  //   return id;
  // }, [file, form, onFileUpload]);
  const handleFileUpload = useCallback(async () => {
    // 检查是否有文件
    if (file.length === 0) {
      setUploadStatus(uploadStatusVariants.noUpload);
      notifier.error("请选择文件");
      return "";
    }
    // 状态改为上传中
    setUploadStatus(uploadStatusVariants.waitUpload);

    // 存储上传成功的文件 ID
    const ids = [];
    // let totalPercent = 0;
    // 遍历文件数组并执行上传操作
    for (const upfile of file) {
      // 开始 并等待上传
      const [isSuccess, id, message] = await onFileUpload(
        upfile,
        (percent, loaded, total) => {
          console.log('percent', percent)
          // totalPercent += percent;
        }
      );
      if (isSuccess) {
        logger.log("上传完成", isSuccess, upfile.name, id, form);
        ids.push(id);
      } else {
        // 状态改为上传失败 message
        const noUpload = { ...uploadStatusVariants.noUpload };
        noUpload.message = message;
        setUploadStatus(noUpload);
        return null;
      }
    }
    // const averagePercent = totalPercent / file.length;
    // console.log('avp',file.length,averagePercent)
    setUploadStatus({
      ...uploadStatusVariants.waitUpload,
      // message: `${uploadStatusVariants.waitUpload.message} ${averagePercent}%`,
    });
    if (ids.length === file.length) {
      setUploadStatus(uploadStatusVariants.uploaded);
      setForm((f) => ({ ...f, fileId: ids }));
    }
    return ids;
  }, [file, form, onFileUpload]);
  //别管
  const handlePluginAdd = useCallback(async () => {
    if (!validate()) {
      notifier.error("请完善表单");
      return;
    }
    if (file.length > 1 && file.length != descFile.length) {
      notifier.error("固件文件与描述信息不一致");
      return;
    }
    if (form?.pluginVerHash.length == form?.buildTime.length) {
      for (let i = 0; i < form.pluginVerHash.length; i++) {
        let copy = { ...form };
        copy.pluginVerHash = form.pluginVerHash[i];
        copy.buildTime = form.buildTime[i];
        copy.publishSystem = form.publishSystem[i];
        if (!copy.fileId) {
          const id = await handleFileUpload();
          copy.fileId = id[i];
        }
        if (!copy.fileId) {
          notifier.error("已取消提交，无有效的文件Id");
          return;
        }

        copy.publishFlag = Number(form.publishFlag);
        logger.log("添加插件版本的表单信息： ", copy);
        const flag = await onPluginVerAdd(copy);
        if (flag) {
          setForm({ pluginAppId, ...defaultFormNoPluginAppId });
          setFile([]);
          setUploadStatus(uploadStatusVariants.noUpload);
        }
      }
    }

  }, [form, handleFileUpload, onPluginVerAdd, pluginAppId, validate]);

  const handlePluginUpdate = useCallback(async () => {
    if (!validate()) {
      notifier.error("请完善表单");
      return;
    }

    const id = data?.id;
    const copy = { ...form };

    if (file.length !== 0) {
      const id = await handleFileUpload();
      copy.fileId = id;
    }

    if (!copy.fileId) {
      notifier.error("已取消提交，无有效的文件Id");
      return;
    }

    copy.publishFlag = Number(form.publishFlag);
    logger.log("修改插件版本的表单信息： ", id, copy);
    console.log('copy',copy)
    const flag = await onPluginVerUpdate(id, copy);
    if (flag) {
      setFile([]);
      setUploadStatus(uploadStatusVariants.noUpload);
    }
  }, [data, file, form, handleFileUpload, onPluginVerUpdate, validate]);

  // 根据type变化
  const typeVariants = {
    add: { title: "添加插件版本", label: "Add", submit: handlePluginAdd },
    update: {
      title: "修改插件版本",
      label: "Update",
      submit: handlePluginUpdate,
    },
  };

  // 解析描述文件
  const [descFile, setDescFile] = useState([])
  const handleDescFile = useCallback(async (files) => {
    setDescFile(files)
    const time = [];
    const hash = [];
    for (let i = 0; i < files.length; i++) {
      const descFile = files[i];
      let text = "";
      let desc = "";
      try {
        text = await util.readFileAsText(descFile);
        desc = JSON.parse(text);
        if (desc) {
          time.push(desc.build_time || "")
          hash.push(desc.file_hash || "")
        }
        desc &&
          setForm((f) => {
            return {
              ...f,
              // buildTime: desc.build_time || "",
              changeInfo: desc.change_info || "",
              changeInfoEn: desc.change_info_en || "",
              version: desc.version || "",
              // pluginVerHash: desc.file_hash || "",
            };
          });
      } catch (e) {
        logger.error(e);
        notifier.error(e.message);
      }
      console.log("描述文件：", descFile, "\n", text, "\n", desc);
    }
    setForm((f) => {
      return {
        ...f,
        buildTime: time,
        pluginVerHash: hash
      }
    })
  }, []);
  const MiniFileInput = useMemo(() => {
    return (
      <FileInput
        containerCss={css`
          position: absolute;
          top: 0;
          right: 0;
          z-index: 1;
        `}
        placeholder="描述文件拖至或 "
        buttonText="选择"
        mini
        onChange={(e) => handleDescFile(e.currentTarget.files)}
      />
    );
  }, []);

  // 如果是修改 并且 修改时要显示目标插件
  if (type === "update" && displayTargetPlugin) {
    return (
      <Modal
        visible={visible}
        onClose={() => {
          // 关闭时清除文件和文件状态 fileInput在关闭打开后会丢失文件名 避免视图不一致
          setUploadStatus(uploadStatusVariants.noUpload);
          // 更新时不清除fileId
          setFile([]);
          setDescFile([]);
          onClose();
        }}
      >
        <StyledDoublePluginVerModal
          onKeyUp={(e) => {
            e.preventDefault();
            //阻止事件进一步传播
            e.stopPropagation();
            switch (e.keyCode) {
              //回车 提交
              case 13:
                typeVariants.update.submit();
                break;
              //Esc 取消
              case 27:
                console.log("取消");
                onClose && onClose();
                setUploadStatus(uploadStatusVariants.noUpload);
                break;
              default:
                return;
            }
          }}
        >
          <FormTitle>{typeVariants.update.title}</FormTitle>
          <StyledPluginVerModal>
            <InputGroup
              width="100%"
              label={`文件 大小：${data?.fileSize || ""}`}
              type="text"
              name="fileName"
              title={data.fileId}
              value={data?.fileName || "无文件"}
              disabled
            />
            <InputGroup
              width="100%"
              label="版本信息"
              type="text"
              name="changeInfo"
              value={data?.changeInfo}
              disabled
              placeholder="changeInfo"
            />
            <InputGroup
              width="100%"
              label="desc"
              type="text"
              name="changeInfoEn"
              value={data?.changeInfoEn}
              disabled
              placeholder="changeInfoEn"
            />
            <InputGroup
              width="100%"
              label="编译时间"
              type="text"
              name="buildTime"
              value={data?.buildTime}
              placeholder="buildTime"
              disabled
            />
            <InputGroup
              width="100%"
              label="版本号"
              type="text"
              name="version"
              value={data?.version}
              disabled
              placeholder="version"
            />
            <InputGroup
              width="100%"
              label="版本Hash"
              type="text"
              name="pluginVerHash"
              value={data?.pluginVerHash}
              disabled
              placeholder="pluginVerHash"
            />
            <StyledSelectGroup>
              <StyledSelectLabel>发布标志</StyledSelectLabel>-
              <span>{data?.publishSystem}</span>-
              <span>{data?.publishFlagDesc}</span>
            </StyledSelectGroup>
          </StyledPluginVerModal>
          <StyledMiddle tips="修改为">
            <FontAwesomeIcon icon={faShare} size="lg" />
          </StyledMiddle>
          <StyledPluginVerModal>
            <InputGroup
              width="100%"
              label="更新文件(可为空)"
              type="file"
              title={form.fileId}
              status={uploadStatus}
              onChange={handleFile}
            />
            <DropArea enable onDropFile={handleDescFile}>
              {({ dropAreaRef, areaCss }) => {
                return (
                  <StyledDescArea ref={dropAreaRef} areaCss={areaCss}>
                    {MiniFileInput}
                    <InputGroup
                      width="100%"
                      label="新版本信息"
                      type="text"
                      name="changeInfo"
                      value={form.changeInfo}
                      onChange={handleValueChange}
                      placeholder="changeInfo"
                    />
                    <InputGroup
                      width="100%"
                      label="新desc"
                      type="text"
                      name="changeInfoEn"
                      value={form.changeInfoEn}
                      onChange={handleValueChange}
                      placeholder="changeInfoEn"
                    />
                    <InputGroup
                      width="100%"
                      label="新编译时间"
                      type="text"
                      name="buildTime"
                      value={form.buildTime}
                      onChange={handleValueChange}
                      placeholder="buildTime"
                    />
                    <InputGroup
                      width="100%"
                      label="新版本号"
                      type="text"
                      name="version"
                      value={form.version}
                      onChange={handleValueChange}
                      placeholder="version"
                    />
                    <InputGroup
                      width="100%"
                      label="新版本Hash(可选)"
                      type="text"
                      name="pluginVerHash"
                      value={form.pluginVerHash}
                      onChange={handleValueChange}
                      placeholder="pluginVerHash"
                    />
                  </StyledDescArea>
                );
              }}
            </DropArea>

            <StyledSelectGroup>
              <StyledSelectLabel>新发布标志</StyledSelectLabel>-
              <StyledSelect
                options={publishSystem}
                name="publishSystem"
                value={form.publishSystem}
                onChange={handleValueChange}
              />
              -
              <StyledSelect
                options={flagOptions}
                name="publishFlag"
                value={form.publishFlag}
                onChange={handleValueChange}
              />
            </StyledSelectGroup>
          </StyledPluginVerModal>
          <StyledButtonGroup>
            <Button message={errorMessage} onClick={typeVariants.update.submit}>
              {typeVariants.update.label}
            </Button>
          </StyledButtonGroup>
        </StyledDoublePluginVerModal>
      </Modal>
    );
  }
  return (
    <Modal
      visible={visible}
      onClose={() => {
        // 关闭时清除文件和文件状态 fileInput在关闭打开后会丢失文件名 避免视图不一致
        setUploadStatus(uploadStatusVariants.noUpload);
        setForm((f) => ({ ...f, fileId: "" }));
        setFile([]);
        setDescFile([]);
        onClose();
      }}
    >
      <StyledPluginVerModal
        onKeyUp={(e) => {
          e.preventDefault();
          //阻止事件进一步传播
          e.stopPropagation();
          switch (e.keyCode) {
            //回车 提交
            case 13:
              typeVariants[type] && typeVariants[type].submit();
              break;
            //Esc 取消
            case 27:
              console.log("取消");
              onClose && onClose();
              setUploadStatus(uploadStatusVariants.noUpload);
              break;
            default:
              return;
          }
        }}
      >
        <FormTitle>{typeVariants[type]?.title}</FormTitle>
        {/* <input type="file" onChange={handleFile} /> */}
        <InputGroup
          width="100%"
          label="固件文件"
          type="file"
          title={form.fileId}
          status={uploadStatus}
          onChange={handleFile}
        />
        <DropArea enable onDropFile={handleDescFile}>
          {({ dropAreaRef, areaCss }) => {
            return (
              <StyledDescArea ref={dropAreaRef} areaCss={areaCss}>
                {MiniFileInput}
                <InputGroup
                  width="100%"
                  label="版本信息"
                  type="text"
                  name="changeInfo"
                  value={form.changeInfo}
                  onChange={handleValueChange}
                  placeholder="changeInfo"
                />
                <InputGroup
                  width="100%"
                  label="版本信息"
                  type="text"
                  name="changeInfoEn"
                  value={form.changeInfoEn}
                  onChange={handleValueChange}
                  placeholder="changeInfoEn"
                />
                <InputGroup
                  width="100%"
                  label="编译时间"
                  type="text"
                  name="buildTime"
                  value={form.buildTime}
                  onChange={handleValueChange}
                  placeholder="buildTime"
                />
                <InputGroup
                  width="100%"
                  label="版本号"
                  type="text"
                  name="version"
                  value={form.version}
                  onChange={handleValueChange}
                  placeholder="version"
                />
                <InputGroup
                  width="100%"
                  label="版本Hash(可选)"
                  type="text"
                  name="pluginVerHash"
                  value={form.pluginVerHash}
                  onChange={handleValueChange}
                  placeholder="pluginVerHash"
                />
              </StyledDescArea>
            );
          }}
        </DropArea>

        <StyledSelectGroup>
          <StyledSelectLabel>发布标志</StyledSelectLabel>
          -
          <StyledSelect
            options={publishSystem}
            name="publishSystem"
            value={form.publishSystem}
            onChange={handleValueChange}
          />
          -
          <StyledSelect
            options={flagOptions}
            name="publishFlag"
            value={form.publishFlag}
            onChange={handleValueChange}
          />
        </StyledSelectGroup>
        <Button message={errorMessage} onClick={typeVariants[type]?.submit}>
          {typeVariants[type]?.label}
        </Button>
      </StyledPluginVerModal>
    </Modal>
  );
};

export default PluginVerModal;
